import image from '@/assets/blog/backup-blog-image/outdoorsy-trip.jpg';
import image05 from '@/assets/blog/backup-blog-image/outdoorsy-trip@0.5x.jpg';
import image025 from '@/assets/blog/backup-blog-image/outdoorsy-trip@0.25x.jpg';
import image033 from '@/assets/blog/backup-blog-image/outdoorsy-trip@0.33x.jpg';
import image075 from '@/assets/blog/backup-blog-image/outdoorsy-trip@0.75x.jpg';
import { IImages } from '@/services/types/blog/post.types';

const backupImages: IImages = {
  full: {
    source_url: image,
    width: 1920,
    height: 1080,
  },
  large: {
    source_url: image075,
    width: 1440,
    height: 810,
  },
  medium: {
    source_url: image05,
    width: 960,
    height: 540,
  },
  small: {
    source_url: image033,
    width: 634,
    height: 356,
  },
  thumbnail: {
    source_url: image025,
    width: 480,
    height: 270,
  },
};

export default backupImages;
